import React, { useState } from "react";
import SidebarClose from "../../assest/svg/sidebar_close.svg";
import NewChat from "../../assest/svg/new_chat.svg";
import Chat from "../../assest/svg/Chat.svg";
import Tool from "../../assest/svg/Tool.svg";
import { ChatType } from "../../api/types/allChatType";
import ProjectCreateForm from "../../project";
import Trash from "../../assest/svg/Trash.svg";
import { UseThradeDeleteMutation } from "../../api/mutation/useThradeDeleteMutation";
import { useAllChatsQuery } from "../../api/query/useAllChatsQuery";
import Loader from "../../assest/loader.svg";
import LeftArrow from "../../assest/svg/LeftArrow.svg";
import Logo from "../../assest/favicon.png";

interface SidebarProps {
  messages: ChatType[];
  thread_id: string;
  onClose: () => void;
  selectedChatId: (thread_id: string) => void;
  newChat: () => void;
  isBubble: boolean;
}

export const Sidebar = ({
  messages,
  thread_id,
  onClose,
  selectedChatId,
  newChat,
  isBubble,
}: SidebarProps) => {
  const [openForm, setOpenForm] = useState(false);
  const [thradeToDelete, setThradeToDelete] = useState("");
  const [openSide, setOpenSide] = useState<string>("Chat");
  const fetchAllChat = useAllChatsQuery(localStorage.getItem("user_id"));
  const useThradeDeleteMutation = UseThradeDeleteMutation();

  const deleteThrade = (id: string) => {
    useThradeDeleteMutation.mutate(
      { thread_ID: id },
      {
        onSuccess() {
          setThradeToDelete("");
          fetchAllChat.refetch();
        },
        onError(error) {
          console.error("Error deleting thread:", error);
        },
      }
    );
  };

  return (
    <aside
      className="h-full font-sans flex flex-row relative select-none transition-all duration-300"
      aria-label="Sidebar Navigation"
    >
      {/* Loading overlay during thread deletion */}
      {useThradeDeleteMutation.isPending && (
        <div className="absolute inset-0 z-50 bg-black/60 backdrop-blur-sm flex justify-center items-center">
          <img
            className="w-16 h-16 animate-spin"
            alt="Suppression..."
            src={Loader}
          />
        </div>
      )}

      {!isBubble ? (
        <div className="flex h-full">
          {/* SLIM LEFT ICON RAIL */}
          <div className="w-16 min-w-[4rem] h-full flex flex-col items-center justify-between py-4 bg-slate-100 dark:bg-[#090A0F] border-r border-slate-200 dark:border-white/5 transition-colors">
            {/* Top Logo & Primary Navigation */}
            <div className="flex flex-col items-center gap-5 w-full">
              <button
                type="button"
                onClick={newChat}
                className="hover:scale-105 transition-transform p-1 rounded-xl focus:outline-none focus:ring-2 focus:ring-purple-500/40"
                title="Continuum AI"
              >
                <img className="w-8 min-w-8 object-contain" src={Logo} alt="Continuum" />
              </button>

              <div className="w-8 h-[1px] bg-slate-300 dark:bg-white/10 my-1" />

              {/* Chat tab icon */}
              <button
                type="button"
                className={`p-2.5 rounded-xl transition-all duration-200 relative group ${
                  openSide === "Chat"
                    ? "bg-purple-600/20 text-purple-400 border border-purple-500/40 shadow-glow-purple"
                    : "text-slate-500 dark:text-slate-400 hover:bg-slate-200/70 dark:hover:bg-white/5 hover:text-slate-900 dark:hover:text-white"
                }`}
                onClick={() => setOpenSide(openSide === "Chat" ? "" : "Chat")}
                title="Discussions"
              >
                <img
                  className="w-5 h-5 dark:invert opacity-90 group-hover:opacity-100"
                  src={Chat}
                  alt="Discussions"
                />
                {openSide === "Chat" && (
                  <span className="absolute left-0 top-1/2 -translate-y-1/2 w-1 h-5 bg-purple-500 rounded-r-full" />
                )}
              </button>

              {/* Tools / Gantt tab icon */}
              <button
                type="button"
                className={`p-2.5 rounded-xl transition-all duration-200 relative group ${
                  openSide === "Tool" || openForm
                    ? "bg-purple-600/20 text-purple-400 border border-purple-500/40 shadow-glow-purple"
                    : "text-slate-500 dark:text-slate-400 hover:bg-slate-200/70 dark:hover:bg-white/5 hover:text-slate-900 dark:hover:text-white"
                }`}
                onClick={() => setOpenSide(openSide === "Tool" ? "" : "Tool")}
                title="Outils & Planning Gantt"
              >
                <img
                  className="w-5 h-5 dark:invert opacity-80 group-hover:opacity-100"
                  src={Tool}
                  alt="Outils"
                />
                {(openSide === "Tool" || openForm) && (
                  <span className="absolute left-0 top-1/2 -translate-y-1/2 w-1 h-5 bg-purple-500 rounded-r-full" />
                )}
              </button>
            </div>
          </div>

          {/* EXPANDED DRAWER PANEL */}
          {openSide && (
            <div className="w-64 min-w-[16rem] h-full flex flex-col justify-between p-3.5 bg-white dark:bg-[#10121A] border-r border-slate-200 dark:border-white/5 shadow-xl transition-all duration-300 animate-fadeIn">
              <div className="flex flex-col h-[calc(100%-40px)]">
                {/* Header of Drawer */}
                <div className="flex justify-between items-center pb-3 border-b border-slate-100 dark:border-white/5">
                  <div className="flex items-center gap-2">
                    <img className="w-5 h-5 object-contain" src={Logo} alt="Continuum" />
                    <span className="font-display font-semibold text-sm tracking-wider uppercase text-slate-800 dark:text-slate-200">
                      Continuum
                    </span>
                  </div>
                  <button
                    type="button"
                    className="p-1.5 rounded-lg text-slate-400 hover:text-slate-700 dark:hover:text-slate-200 hover:bg-slate-100 dark:hover:bg-white/5 transition-colors"
                    onClick={() => setOpenSide("")}
                    title="Réduire"
                  >
                    <img
                      src={LeftArrow}
                      alt="Fermer"
                      className="w-4 h-4 opacity-70 dark:invert"
                    />
                  </button>
                </div>

                {/* "Nouvelle discussion" Button */}
                <button
                  type="button"
                  onClick={newChat}
                  className="my-3.5 px-3.5 py-2.5 w-full font-medium text-xs rounded-xl flex justify-between items-center transition-all duration-300 bg-gradient-to-r from-purple-600/15 via-indigo-600/15 to-cyan-500/10 hover:from-purple-600/25 hover:to-cyan-500/20 text-purple-950 dark:text-purple-200 border border-purple-500/30 dark:border-purple-500/40 shadow-sm hover:shadow-glow-purple group"
                >
                  <span className="flex items-center gap-2">
                    <span className="text-purple-500 font-bold text-base leading-none">+</span>
                    Nouvelle discussion
                  </span>
                  <kbd className="px-1.5 py-0.5 text-[10px] font-mono text-purple-600 dark:text-purple-300 bg-purple-500/10 dark:bg-purple-400/10 border border-purple-500/20 rounded">
                    ⌘K
                  </kbd>
                </button>

                {/* Content based on Active Tab */}
                {openSide === "Chat" && (
                  <div className="flex flex-col flex-1 min-h-0">
                    <div className="mb-2 px-1 flex justify-between items-center text-[11px] font-semibold tracking-wider uppercase text-slate-400 dark:text-slate-500">
                      <span>Anciennes discussions</span>
                      <span className="text-[10px] px-1.5 py-0.5 rounded-full bg-slate-100 dark:bg-white/5 text-slate-500 dark:text-slate-400">
                        {messages?.length ?? 0}
                      </span>
                    </div>

                    {/* Chat History List */}
                    <div className="overflow-y-auto flex-1 pr-1 space-y-1">
                      {messages && messages.length > 0 ? (
                        messages.map((chat: ChatType) => {
                          const isActive = chat.thread_id === thread_id;
                          return (
                            <div
                              key={chat.thread_id}
                              className={`rounded-xl flex justify-between items-center px-3 py-2.5 text-xs group cursor-pointer transition-all duration-200 ${
                                isActive
                                  ? "bg-purple-500/10 dark:bg-purple-500/15 text-purple-900 dark:text-purple-200 border border-purple-500/30 font-medium shadow-sm"
                                  : "text-slate-600 dark:text-slate-300 hover:bg-slate-100/80 dark:hover:bg-white/5 border border-transparent"
                              }`}
                              onClick={() => selectedChatId(chat.thread_id)}
                            >
                              <div className="truncate whitespace-nowrap flex-1 mr-2">
                                {chat.content || "Discussion sans titre"}
                              </div>
                              <button
                                type="button"
                                className="opacity-0 group-hover:opacity-100 p-1 hover:bg-red-500/10 rounded transition-opacity"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  setThradeToDelete(chat.thread_id);
                                }}
                                title="Supprimer"
                              >
                                <img
                                  src={Trash}
                                  alt="Supprimer"
                                  className="w-3.5 h-3.5 opacity-60 hover:opacity-100 dark:invert"
                                />
                              </button>
                            </div>
                          );
                        })
                      ) : (
                        <div className="text-center py-8 text-xs text-slate-400 dark:text-slate-500">
                          Aucune discussion passée
                        </div>
                      )}
                    </div>
                  </div>
                )}

                {openSide === "Tool" && (
                  <div className="flex flex-col flex-1 min-h-0 my-2">
                    <div className="mb-2 px-1 text-[11px] font-semibold tracking-wider uppercase text-slate-400 dark:text-slate-500">
                      Outils de Gestion
                    </div>
                    <button
                      type="button"
                      className="p-3 w-full text-left rounded-xl transition-all duration-200 bg-slate-50 dark:bg-[#161924] hover:bg-purple-500/10 dark:hover:bg-purple-500/15 border border-slate-200 dark:border-white/10 text-slate-800 dark:text-slate-200 group"
                      onClick={() => setOpenForm(true)}
                    >
                      <div className="flex items-center gap-2.5">
                        <div className="p-2 rounded-lg bg-purple-600/15 text-purple-400 border border-purple-500/30">
                          <img src={Tool} alt="Gantt" className="w-4 h-4 dark:invert" />
                        </div>
                        <div>
                          <p className="text-xs font-semibold">Planning Gantt</p>
                          <p className="text-[11px] text-slate-400 dark:text-slate-400">
                            Génération & Export Excel
                          </p>
                        </div>
                      </div>
                    </button>
                  </div>
                )}
              </div>

              {/* Bottom Status Bar */}
              <div className="pt-2 border-t border-slate-100 dark:border-white/5 flex items-center justify-between text-[10px] text-slate-400 dark:text-slate-500">
                <div className="flex items-center gap-1.5">
                  <span className="w-1.5 h-1.5 rounded-full bg-emerald-500 animate-pulse" />
                  <span>Continuum AI • En ligne</span>
                </div>
                <span title="Session sécurisée">🛡️</span>
              </div>
            </div>
          )}
        </div>
      ) : (
        /* BUBBLE / MOBILE VIEW */
        <div className="p-3 w-full h-full flex flex-col bg-white dark:bg-[#10121A]">
          <div className="flex items-center justify-between w-full mb-4">
            <div className="flex items-center gap-2">
              <img className="w-7 h-7 object-contain" src={Logo} alt="Continuum" />
              <span className="font-display font-semibold text-sm text-slate-800 dark:text-slate-200">
                Continuum
              </span>
            </div>
            <button
              onClick={onClose}
              className="p-1 rounded-lg hover:bg-slate-100 dark:hover:bg-white/5"
            >
              <img
                className="w-5 h-5 dark:invert opacity-70"
                src={SidebarClose}
                alt="Fermer"
              />
            </button>
          </div>

          <button
            type="button"
            className="mb-4 px-3.5 py-2.5 w-full font-medium text-xs rounded-xl flex justify-between items-center bg-gradient-to-r from-purple-600/15 via-indigo-600/15 to-cyan-500/10 text-purple-950 dark:text-purple-200 border border-purple-500/30 shadow-sm"
            onClick={newChat}
          >
            <span className="flex items-center gap-2">
              <span className="text-purple-500 font-bold">+</span>
              Nouvelle discussion
            </span>
            <img className="w-4 h-4 dark:invert opacity-60" src={NewChat} alt="" />
          </button>

          <div className="flex flex-col gap-1 overflow-y-auto flex-1 pr-1">
            {messages &&
              messages.map((chat: ChatType) => {
                const isActive = chat.thread_id === thread_id;
                return (
                  <div
                    key={chat.thread_id}
                    className={`rounded-xl flex justify-between items-center px-3 py-2 text-xs cursor-pointer transition-all ${
                      isActive
                        ? "bg-purple-500/15 text-purple-300 border border-purple-500/40"
                        : "text-slate-400 hover:bg-white/5"
                    }`}
                    onClick={() => selectedChatId(chat.thread_id)}
                  >
                    <span className="truncate">{chat.content || "Discussion"}</span>
                    <img
                      src={Trash}
                      alt="Supprimer"
                      className="w-3.5 h-3.5 opacity-50 hover:opacity-100 dark:invert ml-2"
                      onClick={(e) => {
                        e.stopPropagation();
                        setThradeToDelete(chat.thread_id);
                      }}
                    />
                  </div>
                );
              })}
          </div>
        </div>
      )}

      {/* MODAL: PLANNING GANTT FORM */}
      {openForm && (
        <div className="fixed inset-0 z-50 bg-slate-900/40 dark:bg-black/70 backdrop-blur-md flex justify-center items-center p-4 md:p-6 animate-fadeIn">
          <div className="bg-white dark:bg-[#131622] text-slate-800 dark:text-slate-100 border border-slate-200 dark:border-white/10 rounded-2xl p-6 w-full max-w-4xl max-h-[90vh] shadow-2xl flex flex-col overflow-hidden">
            <ProjectCreateForm close={() => setOpenForm(false)} />
          </div>
        </div>
      )}

      {/* MODAL: DELETE CONFIRMATION */}
      {thradeToDelete && (
        <div className="fixed inset-0 z-50 bg-black/70 backdrop-blur-sm flex justify-center items-center p-4 animate-fadeIn">
          <div className="bg-white dark:bg-[#161924] border border-slate-200 dark:border-white/10 rounded-2xl p-6 max-w-sm w-full shadow-2xl text-center">
            <div className="w-12 h-12 rounded-full bg-red-500/10 text-red-500 flex items-center justify-center mx-auto mb-3">
              <img src={Trash} alt="" className="w-6 h-6 dark:invert" />
            </div>
            <h3 className="text-base font-semibold text-slate-900 dark:text-white mb-1 font-display">
              Supprimer la discussion ?
            </h3>
            <p className="text-xs text-slate-500 dark:text-slate-400 mb-5">
              Cette action est irréversible. L'historique de cet échange sera définitivement supprimé.
            </p>
            <div className="flex gap-3 justify-center">
              <button
                type="button"
                className="px-4 py-2 rounded-xl text-xs font-medium bg-slate-100 dark:bg-white/5 hover:bg-slate-200 dark:hover:bg-white/10 text-slate-700 dark:text-slate-300 transition-colors"
                onClick={() => setThradeToDelete("")}
              >
                Annuler
              </button>
              <button
                type="button"
                className="px-4 py-2 rounded-xl text-xs font-medium bg-red-600 hover:bg-red-700 text-white shadow-md transition-colors"
                onClick={() => deleteThrade(thradeToDelete)}
              >
                Supprimer
              </button>
            </div>
          </div>
        </div>
      )}
    </aside>
  );
};

export default Sidebar;
